var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19C2.45 19 1.979 18.804 1.587 18.412C1.195 18.02 0.999335 17.5493 1 17V3C1 2.45 1.196 1.979 1.588 1.587C1.98 1.195 2.45067 0.999335 3 1H7C7.55 1 8.021 1.196 8.413 1.588C8.805 1.98 9.00067 2.45067 9 3V17C9 17.55 8.804 18.021 8.412 18.413C8.02 18.805 7.54933 19.0007 7 19H3ZM13 8C12.45 8 11.979 7.804 11.587 7.412C11.195 7.02 10.9993 6.54933 11 6V3C11 2.45 11.196 1.979 11.588 1.587C11.98 1.195 12.4507 0.999335 13 1H17C17.55 1 18.021 1.196 18.413 1.588C18.805 1.98 19.0007 2.45067 19 3V6C19 6.55 18.804 7.021 18.412 7.413C18.02 7.805 17.5493 8.00067 17 8H13ZM13 19C12.45 19 11.979 18.804 11.587 18.412C11.195 18.02 10.9993 17.5493 11 17V12C11 11.45 11.196 10.979 11.588 10.587C11.98 10.195 12.4507 9.99933 13 10H17C17.55 10 18.021 10.196 18.413 10.588C18.805 10.98 19.0007 11.4507 19 12V17C19 17.55 18.804 18.021 18.412 18.413C18.02 18.805 17.5493 19.0007 17 19H13Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.a42f9d0ad2a6b3d517e9ac6d7c458ac3.svg";
export { ForwardRef as ReactComponent };